import React from 'react';
import { string } from 'prop-types';

export default function Icon({ glyph, className = '' }) {
    return (
        <svg className={`svg-icon ${className}`}>
            <use xlinkHref={`#${glyph}`} />
        </svg>
    );
}

Icon.propTypes = {
    glyph: string.isRequired,
    className: string
};

Icon.defaultProps = { className: '' };
